import styled from 'styled-components';

const Row = styled.div.attrs(() => ({
  className: 'row'
}))``;

export default Row;
